/** 영어 표 (키 = 한국어 원문) */
export const MESSAGES_EN = {
    "오름차순 정렬": "Sort ascending",
    "내림차순 정렬": "Sort descending",
    "정렬 해제": "Clear sort",
    "이 컬럼 그룹 해제": "Ungroup this column",
    "이 컬럼으로 그룹": "Group by this column",
    "그룹 패널 표시": "Show group panel",
    "그룹 모두 펼치기": "Expand all groups",
    "그룹 모두 접기": "Collapse all groups",
    "필터…": "Filter…",
    "이 컬럼 필터 지우기": "Clear this column filter",
    "최적 너비": "Best fit",
    "모든 컬럼 최적 너비": "Best fit all columns",
    "왼쪽 고정": "Pin left",
    "오른쪽 고정": "Pin right",
    "이 컬럼 숨기기": "Hide this column",
    "컬럼 표시/순서…": "Columns…",
    "필터 행 표시": "Show filter row",
    "합계 행 표시": "Show summary row",
    "필터 편집…": "Edit filter…",
    "찾기": "Find",
    "그리드 설정…": "Grid settings…",
    "화면 설정 초기화": "Reset layout",
    "복사": "Copy",
    "머리글 포함 복사": "Copy with headers",
    "잘라내기": "Cut",
    "메모 편집…": "Edit note…",
    "메모 삭제": "Delete note",
    "메모 추가…": "Add note…",
    "행 고정 해제": "Unpin row",
    "이 행 위에 고정": "Pin row to top",
    "셀 값으로 필터": "Filter by this value",
    "다시 가리기": "Mask again",
    "마스킹 해제": "Unmask",
    "셀 값 제외 필터": "Exclude this value",
    "행 추가": "Add row",
    "행 삭제": "Delete row",
    "변경 취소": "Revert changes",
    "실행 취소": "Undo",
    "다시 실행": "Redo",
    "찾아 바꾸기…": "Find and replace…",
    "실행 취소 기록…": "Undo history…",
    "차트로 보기…": "Chart selection…",
    "엑셀로 내보내기": "Export to Excel",
    "CSV로 내보내기": "Export to CSV",
    "합계": "Total",
    "평균": "Average",
    "건수": "Count",
    "최소": "Min",
    "최대": "Max",
    "조회된 자료가 없습니다.": "No data.",
    "(빈 값)": "(blank)",
    "서버 모드에서는 그룹을 쓸 수 없습니다": "Grouping is not available in server mode",
    "사유를 입력하세요": "Enter a reason",
    "숫자를 입력하세요": "Enter a number",
    "날짜 형식이 아닙니다 (예: 20261009)": "Not a date (e.g. 20261009)",
    "시간 형식이 아닙니다 (예: 0930, 9:30)": "Not a time (e.g. 0930, 9:30)",
    "목록에 없는 값입니다": "Not in the list",
    "불러오는 중…": "Loading…",
    "다시 시도": "Retry",
    "확인 중…": "Checking…",
    "편집할 수 없는 칸입니다": "This cell is not editable",
    "숫자 값이 없습니다": "No numeric values",
    "찾을 내용을 입력하세요": "Enter text to find",
    "찾는 내용이 없습니다": "No matches",
    "바꿀 내용이 없습니다": "Nothing to replace",
    "메모 내용": "Note",
    "삭제": "Delete",
    "취소": "Cancel",
    "저장": "Save",
    "닫기": "Close",
    "해제": "Unmask",
    "메모를 저장하지 못했습니다: ": "Could not save note: ",
    "확인하지 못했습니다: ": "Could not validate: ",
    "감사 기록 실패 — 해제하지 않음": "Audit log failed — not unmasked",
    "선택 범위 차트": "Selection chart",
    "막대": "Bar",
    "선": "Line",
    "원형": "Pie",
    "실행 취소 기록": "Undo history",
    "기록 없음": "No history",
    "여기까지 실행 취소": "Undo to here",
    "첫 페이지": "First page",
    "이전 페이지": "Previous page",
    "다음 페이지": "Next page",
    "마지막 페이지": "Last page",
    "페이지 크기": "Page size",
    "페이지": "Page",
    "오류 목록": "Error list",
    "데이터 그리드": "Data grid",
    "전체 선택": "Select all",
    "행 번호": "Row number",
    "검색": "Search",
    "전체 체크": "Check all",
    "전체 체크 해제": "Uncheck all",
    "편집 중": "Editing",
    "확인 중": "Validating",
    "오류": "Error",
    "현재 행": "Current row",
    "이전 달": "Previous month",
    "다음 달": "Next month",
    "오늘": "Today",
    "지우기": "Clear",
    "셀 입력": "Cell input",
    "달력": "Calendar",
    "끌어서 채우기": "Drag to fill",
    "필터 (Alt+↓)": "Filter (Alt+↓)",
    "편집": "Edit",
    "체크": "Check",
    "선택": "Select",
    "채우기": "Fill",
    "붙여넣기": "Paste",
    "행 이동": "Move rows",
    "끌어 놓기": "Drop",
    "찾아 바꾸기": "Find and replace",
    "찾을 내용": "Find",
    "바꿀 내용": "Replace with",
    "현재 컬럼만": "Current column only",
    "대소문자": "Match case",
    "셀 전체 일치": "Match entire cell",
    "다음 찾기": "Find next",
    "바꾸기": "Replace",
    "모두 바꾸기": "Replace all",
    "↑ 오름차순": "↑ Ascending",
    "↓ 내림차순": "↓ Descending",
    "날짜 빠른 선택…": "Date presets…",
    "조건": "Condition",
    "조건 없음": "No condition",
    "조건 값": "Condition value",
    "범위 끝 값": "Range end",
    "값 검색": "Search values",
    "(전체 선택)": "(Select all)",
    "필터된 값만": "Filtered values only",
    "다른 필터에 걸러진 값만 보기": "Show only values left by other filters",
    "적용": "Apply",
    "초기화": "Reset",
    "일치하는 값 없음": "No matching values",
    "일치하는 항목 없음": "No matching items",
    "필터 켜기/끄기": "Toggle filter",
    "필터 편집": "Edit filter",
    "최근 필터": "Recent filters",
    "최근 필터…": "Recent filters…",
    "편집…": "Edit…",
    "필터 모두 해제": "Clear all filters",
    "(필터 없음)": "(no filter)",
    "그룹으로 묶을 컬럼의 머리글을 여기로 끌어 놓으세요": "Drag a column header here to group by it",
    "모두 펼치기": "Expand all",
    "모두 접기": "Collapse all",
    "그룹 해제": "Ungroup",
    "그룹 정렬 방향": "Group sort direction",
    "끌어서 순서 변경, 패널 밖으로 끌면 해제": "Drag to reorder, drag out to ungroup",
    "컬럼 표시와 순서": "Columns",
    "컬럼 표시 · 순서": "Columns · order",
    "모두 표시": "Show all",
    "위로": "Up",
    "아래로": "Down",
    "우고정": "Pinned right",
    "좌고정": "Pinned left",
    "이전 (Shift+Enter)": "Previous (Shift+Enter)",
    "다음 (Enter, F3)": "Next (Enter, F3)",
    "닫기 (Esc)": "Close (Esc)",
    "찾기 방식": "Find mode",
    "찾기 (강조)": "Find (highlight)",
    "거르기": "Filter",
    "자연어 질의": "Natural language",
    "부정": "Not",
    "컬럼": "Column",
    "연산자": "Operator",
    "값": "Value",
    "끝 값": "End value",
    "조건 삭제": "Delete condition",
    "결합": "Combine",
    "모두 만족 (AND)": "All (AND)",
    "하나 이상 (OR)": "Any (OR)",
    "+ 조건": "+ Condition",
    "+ 그룹": "+ Group",
    "그룹 삭제": "Delete group",
    "수식": "Expression",
    "필터 수식": "Filter expression",
    "모두 지우기": "Clear all",
    "수식을 입력하세요": "Enter an expression",
    "열람 사유 (필수, 감사 기록에 남습니다)": "Reason (required, kept in the audit log)",
    "직접 입력": "Custom",
    "열람 사유": "Reason",
    "덮어쓰기": "Overwrite",
    "삭제 확정": "Confirm delete",
    "다시 추가": "Re-add",
    "서버 값 받기": "Take server value",
    "선택대로 적용": "Apply choices",
    "다른 그리드로 보내기": "Send to other grid",
    "모두 내 값": "Keep all mine",
    "모두 서버 값": "Take all server values",
    "다른 사용자가 먼저 수정했습니다": "Another user changed this row first",
    "다른 사용자가 삭제했습니다": "Another user deleted this row",
    "서버 오류 {n}건": "{n} server error(s)",
    "입력 확인 {n}건": "{n} input problem(s)",
    "엑셀 만드는 중…": "Building Excel file…",
    "엑셀 받는 중 {n}": "Downloading Excel {n}",
    "서버 변경 있음": "Changed on server",
    "선택 범위 차트 ({rows}행 × {series}계열)": "Selection chart ({rows} rows × {series} series)",
    "보호된 시트입니다 — 행을 추가할 수 없습니다": "The sheet is protected — rows cannot be added",
    "보호된 시트입니다 — 행을 삭제할 수 없습니다": "The sheet is protected — rows cannot be deleted",
    "도구 패널": "Tool panel",
    "필터": "Filters",
    "고정": "Pin",
    "고정 없음": "Not pinned",
    "그룹": "Group",
    "걸린 필터가 없습니다": "No active filters",
    "빼기": "Remove",
    "카드 보기": "Card view",
    "같음": "equals",
    "같지 않음": "not equal",
    "초과": "greater than",
    "이상": "at least",
    "미만": "less than",
    "이하": "at most",
    "포함": "contains",
    "포함 안 함": "does not contain",
    "시작": "starts with",
    "끝": "ends with",
    "패턴(*,?)": "pattern (*,?)",
    "패턴 아님": "not pattern",
    "목록 중": "in list",
    "목록 아님": "not in list",
    "범위": "between",
    "범위 밖": "not between",
    "값 있음": "not blank",
    "sidebar|컬럼": "Columns",
    "sidebar|필터": "Filters",
    "없음": "None",
    "접힘": "collapsed",
    "펼침": "expanded",
    "선택됨": "selected",
    "선택 안 됨": "not selected",
    "빈 값": "blank",
    "일": "Sun",
    "월": "Mon",
    "화": "Tue",
    "수": "Wed",
    "목": "Thu",
    "금": "Fri",
    "토": "Sat",
    "피벗 필드": "Pivot fields",
    "필드": "Fields",
    "행": "Rows",
    "열": "Columns",
    "여기로 끌어 놓기": "Drop here",
    "{a} ~ {b} 밖": "not {a} ~ {b}",
    "어제": "Yesterday",
    "최근 7일": "Last 7 days",
    "최근 30일": "Last 30 days",
    "이번 주": "This week",
    "지난주": "Last week",
    "이번 달": "This month",
    "지난달": "Last month",
    "올해": "This year",
    "오늘 이전": "Before today",
    "오늘 이후": "After today",
    "{col} 필터": "{col} filter",
    "날짜 프리셋": "Date presets",
    " 외 {n}개": " +{n} more",
    "빠른 검색": "Quick search",
    "외부 필터 {n}개": "{n} external filter(s)",
    "조건이 없습니다. \"+ 조건\"을 누르세요.": "No conditions. Click \"+ Condition\".",
    "(조건 없음)": "(no condition)",
    "{n} / {total}건": "{n} / {total} rows",
    "예": "e.g.",
    "컬럼 id": "Column ids",
    "dept = '내과' AND rslt >= 100": "dept = 'IM' AND rslt >= 100",
    "찾기: 단어 공백 = 모두 포함, +필수 -제외 \"구문\" 컬럼:값 김*수": "Find: words = all, +required -exclude \"phrase\" column:value wild*card",
    "해석": "Parsed",
    "모르는 말": "Unknown words",
    "Enter 로 적용": "press Enter to apply",
    "해석한 조건이 없습니다": "No conditions recognized",
    "내과 결과 140 이상 결과 높은 순": "dept result >= 140, sort by result desc",
    "메모": "Note",
    "또는": "or",
    "{col} 내림차순 정렬": "{col} descending",
    "{col} 오름차순 정렬": "{col} ascending",
    "전체 {total}건 중 {max}건만 인쇄했습니다. 필터로 범위를 줄여 주세요.": "Printed only {max} of {total} rows. Narrow the range with a filter.",
    "인쇄": "Print",
    "출력 {stamp}": "Printed {stamp}",
    "{n}건": "{n} rows",
    "담당": "Prepared",
    "검토": "Reviewed",
    "승인": "Approved",
    "인쇄 페이지 설정": "Print page setup",
    "페이지 설정": "Page setup",
    "용지": "Paper",
    "방향": "Orientation",
    "세로": "Portrait",
    "가로": "Landscape",
    "여백(mm)": "Margin (mm)",
    "여백": "Margin",
    "글자 크기(pt)": "Font size (pt)",
    "글자 크기": "Font size",
    "용지 너비에 맞춤": "Fit to page width",
    "그룹마다 새 쪽": "New page per group",
    "배율(%)": "Scale (%)",
    "배율": "Scale",
    "제목": "Title",
    "머리말": "Header",
    "꼬리말": "Footer",
    "결재란": "Approval box",
    "인쇄 컬럼과 순서": "Print columns and order",
    "인쇄 미리보기": "Print preview",
    "컬럼 (체크·순서)": "Columns (check · order)",
    "{col} 위로": "Move {col} up",
    "{col} 아래로": "Move {col} down",
    "컬럼 {n}개": "{n} columns",
    "너비 맞춤": "fit width",
    "designer|그리드 설정": "Grid settings",
    "designer|표시": "Show",
    "designer|순서": "Order",
    "designer|{col} 표시": "Show {col}",
    "designer|(함수)": "(function)",
    "designer|그룹 컬럼": "Group columns",
    "designer|레이아웃 JSON": "Layout JSON",
    "designer|JSON 적용": "Apply JSON",
    "designer|복사": "Copy",
    "designer|컬럼 코드 복사 (개발자)": "Copy column code (developer)",
    "designer|처음 설정으로": "Reset to initial",
    "designer|(개발자)": "(developer)",
    "designer|컬럼": "Columns",
    "designer|그리드": "Grid",
    "designer|레이아웃(JSON)": "Layout (JSON)",
    "designer|바꾸면 바로 적용됩니다.": "Changes apply immediately.",
    "designer|화면 설정은 이 브라우저에 저장됩니다.": "Layout is saved in this browser.",
    "designer|닫기": "Close",
    "designer|레이아웃을 적용했습니다": "Layout applied",
    "designer|JSON 오류": "JSON error",
    "designer|레이아웃 JSON 을 복사했습니다": "Layout JSON copied",
    "designer|컬럼 정의 코드를 복사했습니다 (함수 속성은 원래 코드에서 유지)": "Column definition code copied (function properties stay in the original code)",
    "designer|처음 설정으로 되돌렸습니다": "Reset to initial settings",
    "designer|수식 적용": "expression applied",
    "designer|수식 오류": "Expression error",
    "designer|변경": "changed",
    "designer|머리글": "Header",
    "designer|너비": "Width",
    "designer|고정": "Pin",
    "designer|정렬": "Align",
    "designer|형식": "Format",
    "designer|소수": "Decimals",
    "designer|편집기": "Editor",
    "designer|필수": "Required",
    "designer|합계": "Summary",
    "designer|병합": "Merge",
    "designer|반복숨김": "Suppress repeats",
    "designer|그룹단위": "Group interval",
    "designer|정렬가능": "Sortable",
    "designer|필터가능": "Filterable",
    "designer|수식": "Expression",
    "designer|-": "-",
    "designer|왼쪽": "Left",
    "designer|오른쪽": "Right",
    "designer|자동": "Auto",
    "designer|가운데": "Center",
    "designer|문자": "Text",
    "designer|숫자": "Number",
    "designer|금액": "Money",
    "designer|%": "%",
    "designer|날짜": "Date",
    "designer|일시": "Date-time",
    "designer|읽기전용": "Read-only",
    "designer|콤보": "Combo",
    "designer|체크": "Check",
    "designer|평균": "Average",
    "designer|건수": "Count",
    "designer|최소": "Min",
    "designer|최대": "Max",
    "designer|항상": "Always",
    "designer|정렬 시": "When sorted",
    "designer|값": "Value",
    "designer|일": "Day",
    "designer|월": "Month",
    "designer|년": "Year",
    "designer|첫글자": "First letter",
    "designer|행 번호": "Row numbers",
    "designer|필터 행": "Filter row",
    "designer|합계 행": "Summary row",
    "designer|그룹 패널": "Group panel",
    "designer|그룹 컬럼 숨김": "Hide grouped columns",
    "designer|필터 패널": "Filter panel",
    "designer|필터 있을 때": "When filtered",
    "designer|숨김": "Hidden",
    "designer|헤더 필터 메뉴": "Header filter menu",
    "designer|찾기(Ctrl+F)": "Find (Ctrl+F)",
    "designer|행 높이": "Row height",
    "designer|합계 이름": "Summary label",
    "designer|편집 가능": "Editable",
    "designer|행 상태 표시": "Row state",
    "designer|체크 컬럼": "Check column",
    "designer|Enter 이동": "Enter moves to",
    "designer|다음 입력칸": "Next input",
    "designer|아래 행": "Row below",
    "designer|마지막 칸에서 새 행": "New row from last cell",
    "designer|증분 검색": "Incremental search",
    "designer|행 드래그": "Row drag",
    "designer|자료 없음 문구": "Empty text",
    "그제": "2 days ago",
    "작년": "Last year",
    "최근 {n}일": "Last {n} days",
    "최근 {n}주": "Last {n} weeks",
    "최근 {n}개월": "Last {n} months",
    "최근 {n}년": "Last {n} years",
    "값 검색 ({n}개)": "Search values ({n})",
    "최근": "Recent",
    "값1,값2,…": "value1,value2,…",
    "아목*캡?": "amox*cap?",
    "{n}개 더 있음 — 검색으로 좁히세요": "{n} more — narrow with search",
    "선택한 {n}건을 삭제할까요?": "Delete {n} selected row(s)?",
    "삭제 확인": "Confirm delete",
    "새 항목 행": "New item row",
    "여기를 클릭해 새 행 추가": "Click here to add a new row",
    "새 행 추가": "Add new row",
    "입력 형식이 맞지 않습니다": "Input does not match the format",
    "날짜·시간 형식이 아닙니다 (예: 20261009 0930)": "Not a date/time (e.g. 20261009 0930)",
    "{d} 이후 날짜만 입력할 수 있습니다": "Date must be on or after {d}",
    "{d} 이전 날짜만 입력할 수 있습니다": "Date must be on or before {d}",
    "주": "Wk",
    "시간": "Time",
    "1시간 전": "1 hour earlier",
    "1시간 후": "1 hour later",
    "10분 전": "10 minutes earlier",
    "10분 후": "10 minutes later",
    "지금": "Now",
    "행 편집": "Edit row",
    "행 {n}": "Row {n}",
    "새 행": "new row",
    "Enter 저장 · Esc 취소": "Enter save · Esc cancel",
    "폼 편집": "Form edit",
    "아니오": "No",
    "미정": "Undetermined",
    "코드": "Code",
    "명칭": "Name",
    "목록 {n}건": "list of {n}",
    "눌러서 정렬": "Click to sort",
    "건": "",
    "—": "—",
    // 15차: 입력 정합성·입력 편의
    "경고 {n}건 — 그래도 저장할까요?": "{n} warning(s) — save anyway?",
    "저장 확인": "Confirm save",
    "{col}은(는) 최대 {max}바이트입니다 (지금 {n}바이트)": "{col} allows up to {max} bytes (now {n})",
    "최대 {max}바이트까지 입력할 수 있습니다": "Up to {max} bytes allowed",
    "{n}개 셀은 최대 바이트를 넘어 건너뛰었습니다": "{n} cell(s) skipped: too many bytes",
    "삭제 취소 {n}건": "Restore {n} row(s)",
    "삭제 취소": "Restore row",
    "일괄 입력": "Fill selection",
    "{n}개 셀은 형식이 맞지 않아 건너뛰었습니다": "{n} cell(s) skipped: invalid format",
    "행 되돌리기": "Revert row",
    "행 변경을 되돌렸습니다": "Row changes reverted",
    "경고": "Warning",
    "여러 개 선택": "multi-select",
    "전체 해제": "Clear all",
    "{n}개 선택": "{n} selected",
    "여러 개 선택 (Space)": "Select several (Space)",
    "최대 {n}개까지 고를 수 있습니다": "You can pick up to {n}",
    "이 행의 변경을 저장할까요?": "Save changes to this row?",
    "버림": "Discard",
    "행 저장 (Ctrl+Enter)": "Save row (Ctrl+Enter)",
    "행 취소 (Esc)": "Cancel row (Esc)",
    "오류 {n}건": "{n} error(s)",
    "경고 {n}건": "{n} warning(s)",
    "안내 {n}건": "{n} notice(s)",
    // 16차 (1.2.0): 셀 aria-description 수준 이름
    "안내": "Info",
};
export const LOCALES = { ko: {}, en: MESSAGES_EN };
/** 번역 함수 만들기 (순수) — 표에 없으면 원문(한국어) */
export function makeT(locale = 'ko', overrides) {
    const table = { ...(LOCALES[locale] ?? {}), ...(overrides ?? {}) };
    return (key, vars) => {
        // 'sidebar|컬럼' 처럼 문맥이 붙은 키: 표에 없으면 '|' 뒤 원문
        let s = table[key] ?? (key.includes('|') ? key.slice(key.indexOf('|') + 1) : key);
        if (vars)
            s = s.replace(/\{(\w+)\}/g, (m, k) => (k in vars ? String(vars[k]) : m));
        return s;
    };
}
